import { render, staticRenderFns } from "./KnowledgeBaseDialogChooseYear.vue?vue&type=template&id=1d023422&lang=pug&"
import script from "./KnowledgeBaseDialogChooseYear.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseDialogChooseYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports